export default {
    path:'/terms-of-use',
    preload:false,
    middlewares: []
}
